import { type FormEvent, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export interface AllyInputProps {
  onSend: (value: string) => void;
  placeholder: string;
  messageLabel: string;
  sendLabel: string;
  disabled?: boolean;
}

export function AllyInput({
  onSend,
  placeholder,
  messageLabel,
  sendLabel,
  disabled,
}: AllyInputProps) {
  const [value, setValue] = useState('');

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  }

  return (
    <form className="ally__form" onSubmit={handleSubmit}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        aria-label={messageLabel}
        disabled={disabled}
      />
      <button type="submit" disabled={disabled || !value.trim()} aria-label={sendLabel}>
        <ArrowUp size={18} />
      </button>
    </form>
  );
}
